import gql from "graphql-tag";
import { fetchMethod } from "../../FetchMethod";
import swal from "sweetalert";
export const addNewCampaign = gql`
  mutation CampaignsCreate($obj: JSON) {
    CampaignsCreate(data: $obj) {
      id
    }
  }
`;
export const getCampaignCustomers = gql`
  query($where: JSON) {
    allCustomers(where: $where) {
      Customers {
        id
        company
      }
    }
  }
`;
export const getlinkedinprofiles = gql`
  query($where: JSON) {
    allCustomerlinkedinprofiles(where: $where) {
      Customerlinkedinprofiles {
        id
        linkedinemail
        name
      }
    }
  }
`;

export const getcampaignmanager = gql`
  query($where: JSON) {
    allUsersdata(where: $where) {
      Usersdata {
        id
        firstName
        lastName
      }
    }
  }
`;

export const getcampaignmanagerassignto = gql`
  query {
    allUsersdata(where: { role: "CAMPAIGNMANAGER", order: "firstName" }) {
      Usersdata {
        id
        firstName
        lastName
      }
    }
  }
`;

export const saveCampaignstep = gql`
  mutation CampaignstepsCreate($data: JSON) {
    CampaignstepsCreate(data: $data) {
      id
    }
  }
`;

export const getEditCampaign = id => `
  query {
    allCampaigns(where:{id: ${id},active:${1}}) {
      Campaigns {
        id
        name
        description
        customerid
        linkedinid
        startdate
        salesNavigator
        opencontact
        targetconnections
        zapierurl
        campaignadminid
        campaignmanagerid
        status
        active
        type
        dataoption
        datafromcampaign
        campaignLogo
        workflowtype
      }
    }
  }
`;
export const getEdit = async id =>
  await fetchMethod(getEditCampaign(id))
    .then(response => response.json().then(data => data))
    .catch(e => swal({ title: "Unable to reach server", icon: "warning" }));

export const getStepEdit = campaignid => `
  query {
    allCampaignsteps(where: { campaignid: ${campaignid},active:1 }) {
      Campaignsteps {
        id
        campaignid
        stepname
        sequence
        message
        limitperday
        daysdelay
        active
        subject
      open
      }
    }
  }
`;

export const EditCampaignQuery = gql`
  mutation CampaignsUpsertWithWhere($id: JSON, $data: JSON) {
    CampaignsUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;

export const EditCampaignStepsQuery = gql`
  mutation CampaignstepsUpsertWithWhere($id: JSON, $data: JSON) {
    CampaignstepsUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;
export const getLimitPerDay = gql`
  query {
    allSystemsettings {
      Systemsettings {
        maxvisitperday
        maxfollowperday
        maxconnectionperday
        maxmessageperday
        maxopenmessageperday
      }
    }
  }
`;

const CampaignsSteps = id => `query {
  allCampaignsteps(where: { campaignid: ${id}, active: 1 }) {
    Campaignsteps {
      id
      campaignid
      stepname
      sequence
      message
      limitperday
      daysdelay
      active
      subject
      open
    }
  }
}`;

export const getCampaignsSteps = async id =>
  await fetchMethod(CampaignsSteps(id))
    .then(response => response.json().then(data => data))
    .catch(e => {
      console.log(e);
      swal({ title: "Unable to reach server", icon: "warning" });
    });

export const triggerContacts =  (id, triggerid)=>

  `query {
    allContacts(where:{id: ${id}}) {
    totalCount
    Contacts {
    id
    name
    fname
    invitationsent
    currentstatus
    linkedinid
    campaignid
    profileimage
    image
    profileurl
    connectedon
    email
    industry
    dateofbirth
    location
    organization
    surname
    gender
        country
    state 
    Contactworkflowhistoryfk (where:{status:"SUCCESS"}){
    Contactworkflowhistories{
    campaignstepid
    successflag
    executedon
    nextstep
    contactworkflowhistoryIbfk2rel{
    Campaignsteps{
    stepname 
    
    }
    }
    }
    }
     Contactmessagesfk(where:{order:"realmsgdatetime"}){
Contactmessages{
type
message
messagedatetime
realmsgdatetime
createdon
}
}
    
    Campaigns: campaignIbfk4rel {
    Campaigns {
    name
    customerid
    status
    active
    Customers: customerIbfk1rel {
    Customers {
    company
    }
    }
    }
    }
    designation
    joiningdate
    country
    state
    
    lasteducationinstitute
    twitter
    skype
    phonenumber
    phonetype
    numberoffollowers
    connectedon
    
    createdon
    contactstatus
    campaignstatus
    updatedon
    active
    Contacttriggerfk(where:{id: ${triggerid}}){
      Triggernotifications{
        id
         triggerdata
        triggertype
        url
        date
        triggerstatus
        lastactiondate
        followup
      }
    }
    
    }
    }
    }`;
export const  contacts = id =>

  `query {
    allContacts(where:{id: ${id}}) {
    totalCount
    Contacts {
    id
    name
    fname
    invitationsent
    currentstatus
    linkedinid
    campaignid
    profileimage
    image
    profileurl
    connectedon
    email
    industry
    dateofbirth
    location
    organization
    surname
    gender
        country
    state 
    Contactworkflowhistoryfk (where:{status:"SUCCESS"}){
    Contactworkflowhistories{
    campaignstepid
    successflag
    executedon
    nextstep
    utctasktime
    contactworkflowhistoryIbfk2rel{
    Campaignsteps{
    stepname 
    
    }
    }
    }
    }
     Contactmessagesfk(where:{active:1, order:"realmsgdatetime"}){
Contactmessages{
type
message
messagedatetime
realmsgdatetime
createdon
utcmessagetime
}
}
    
    Campaigns: campaignIbfk4rel {
    Campaigns {
    name
    customerid
    status
    active
    Customers: customerIbfk1rel {
    Customers {
    company
    }
    }
    }
    }
    designation
    joiningdate
    country
    state
    
    lasteducationinstitute
    twitter
    skype
    phonenumber
    phonetype
    numberoffollowers
    connectedon
    
    createdon
    contactstatus
    campaignstatus
    updatedon
    active    
    }
    }
    }`;

export const getContactData = async id =>
  await fetchMethod(contacts(id))
    .then(response => response.json().then(data => data))
    .catch(e => {
      console.log(e);
      swal({ title: e, icon: "warning" });
    });

export const stepLogs = gql`
mutation($data: JSON) {
  CampaignsteplogsCreate(data: $data) {      
    action
    daysdelay
    limitperday
    message
    sequence
    subject
    stepid      
    updatedby
  }
}
`;

export const SendMessages = gql`
  mutation($data: JSON) {
    ContactmessagesCreate(data: $data) {
      id
      message
      createdon
      realmsgdatetime
    }
  }
`;

export const Engaged = id =>
  `query {
  allContacts(where: {id: ${id}}) {
    totalCount
    Contacts {
      id
      name
      fname
      surname
      gender
      linkedinid
      campaignid
      profileimage
      image
      profileurl
      contactstatus
      connectedon
      email
      invitationsent
    currentstatus
      industry
      dateofbirth
      location
      organization
      Contactworkflowhistoryfk(where: {status: "SUCCESS"}) {
        Contactworkflowhistories {
          campaignstepid
          successflag
          executedon
          utctasktime
          contactworkflowhistoryIbfk2rel {
            Campaignsteps {
              stepname
            }
          }
        }
      }
       Contactmessagesfk(where:{active:1, order:"realmsgdatetime"}){
Contactmessages{
type
message
messagedatetime
realmsgdatetime
createdon
utcmessagetime
}
}
      Campaigns: campaignIbfk4rel {
        Campaigns {
          name
          customerid
          status
          active
          Customers: customerIbfk1rel {
            Customers {
              company
            }
          }
        }
      }
      designation
      joiningdate
      country
      lasteducationinstitute
      twitter
      skype
      phonenumber
      phonetype
      numberoffollowers
      createdon
      contactstatus
      campaignstatus
      updatedon
      active
    state 
    }
  }
}
`;

export const dateFilter = gql`
  query($where: JSON) {
    allContactmessages(where: $where) {
      Contactmessages {
        contactid
        type
        messagedatetime
        contactmessagesIbfk1rel {
          Contacts {
            id
            name
          }
        }
      }
    }
  }
`;

export const messageId = gql`
  query($where: JSON) {
    allContacts(where: $where) {
      totalCount
      Contacts {
        id
      }
    }
  }
`;

export const engagedData = gql`
  query($where: JSON) {
    allContacts(where: $where) {
      Contacts {
        id
      }
    }
  }
`;

export const campaignLogMaintain = gql`
  mutation($data: JSON) {
    CampaignlogsCreate(data: $data) {
      id
    }
  }
`;

//update fname in templist
export const UpdatefName = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      fname
    }
  }
`;
//update company in templist
export const UpdateCompany = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      organization
    }
  }
`;
//update posotion in templist
export const UpdatePosition = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      designation
    }
  }
`;
//update Surname in templist
export const UpdateSurname = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      surname
    }
  }
`;
//update country in templist
export const UpdateCountry = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      country
    }
  }
`;
//update state in templist
export const UpdateState = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      state
    }
  }
`;
//update Gender in templist
export const UpdateGender = gql`
  mutation TempcontactsdetailsUpsertWithWhere($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      gender
    }
  }
`;
//update fname in contactlist
export const UpdatefNameContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      fname
    }
  }
`;
//update Surname in contactlist
export const UpdateSurnameContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      surname
    }
  }
`;
//update Email in contactlist
export const UpdateEmailContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      email
    }
  }
`;
//update Phone in contactlist
export const UpdatePhoneContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      phonenumber
    }
  }
`;
//update company in contactlist
export const UpdatePositionContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      designation
    }
  }
`;
//update country in contactlist
export const UpdateCountryContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      country
    }
  }
`;
//update state in contactlist
export const UpdateStateContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      state
    }
  }
`;
//update company in contactlist
export const UpdateCompanyContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      organization
    }
  }
`;
//
//Update Gender in contactlist
export const UpdateGenderContact = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      organization
    }
  }
`;

export const Profileid = id => {
  return `query{
    Campaigns(id: ${id}) {
    id
    name
    customercredentialsIbfk1rel{
    Customerlinkedinprofiles {
     id
     name
     hubspottoken
      salesforcetoken
    }
    }
    }
    }`;
};
//Update Gender in contactlist
export const UpdatefollowUp = gql`
  mutation ContactsUpsertWithWhere($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      followup
    }
  }
`;
export const plannedDate = `query($where:JSON)
{
  allCampaignsteps(where:$where){
  Campaignsteps{
  stepname
  campaignid
  daysdelay
  sequence
  subject
  open
  }
}
  }`;
